import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const CardIntro = () => {
  const features = [
    {
      image: "images/rocket-icon.png",
      title: "Instant Activation",
      description: "Get your virtual card activated within seconds",
    },
    {
      iconClass: "fas fa-credit-card",
      image: "/images/free-icon.png",
      title: "Lifetime Free",
      description: "No annual or maintenance charges",
    },
    {
      iconClass: "fas fa-wallet",
      image: "/images/zero-icon.png",
      title: "Zero Balance",
      description: "No minimum balance requirement",
    },
    {
      iconClass: "fas fa-exchange-alt",
      image: "/images/payment-icon.png",
      title: "Online Payment",
      description:
        "Perfect for online shopping, bill payments, and everyday purchases",
    },
    {
      iconClass: "fas fa-exchange-alt",
      image: "/images/add-money-icon.png",
      title: "Easy Reload",
      description: "Add money instantly via UPI/Bank Transfer",
    },
    {
      iconClass: "fas fa-exchange-alt",
      image: "/images/gift-icon.png",
      title: "Exciting Offers",
      description: "Enjoy discounts/cashback on shopping, travel, and more",
    },
    {
      iconClass: "fas fa-exchange-alt",
      image: "/images/customer-service.png",
      title: "24/7 Customer Support",
      description: "Assistance anytime via phone, chat, or email",
    },
    {
      iconClass: "fas fa-shield-alt",
      image: "/images/secure-icon.png",
      title: "Safe and Secure",
      description: "100% safe, secure card",
    },
  ];

  const comingSoonFeatures = [
    {
      image: "/images/tap-to-pay-icon.png",
      title: "Physical Card",
      description:
        "Get a real prepaid card delivered to your doorstep — coming soon!",
    },
    {
      image: "/images/atm-icon.png",
      title: "ATM Withdrawal",
      description: "Withdraw money from any ATM nationwide — coming soon!",
    },
    {
      image: "/images/upi-logo.png",
      title: "UPI",
      description: "Seamless payments and transfers via UPI — coming soon!",
    },
  ];

  return (
    <React.Fragment>
      <Header />

      <div className="bg-light py-3 px-3  d-flex align-items-center justify-content-center">
        <div className="card rounded-4 w-100" style={{ maxWidth: "1200px" }}>
          <div className="card-body p-3 p-md-3">
            {/* Header */}
            <div className="text-center mb-4">
              <h3 className="fw-bold text-primary">Introducing</h3>
              <h5 className="fw-medium">
                India's First Lifetime Zero Balance Prepaid Card
              </h5>
            </div>

            {/* Card Image */}
            <div className="text-center mb-4">
              <img
                src="/images/formax-pay-card.png"
                alt="Formax Pay Prepaid Card"
                className="img-fluid rounded shadow"
                style={{
                  maxWidth: "240px",
                  transition: "transform 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
            </div>

            {/* Features Section Title */}
            <div className="text-center mb-4">
              <h4 className="fw-bold text-dark">Features</h4>
            </div>

            {/* Features */}
            <div className="row g-3 mb-5">
              {features.map((feature, index) => (
                <div className="col-12 col-sm-6 col-md-3" key={index}>
                  <div
                    className="border rounded bg-white p-3 h-100 text-center d-flex flex-column align-items-center justify-content-start shadow-sm"
                    style={{ minHeight: "160px" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center mb-2 rounded-circle"
                      style={{
                        backgroundColor: "#f2f3f4",
                        color: "white",
                        width: "65px",
                        height: "65px",
                      }}
                    >
                      <img src={`${feature.image}`} width={40} alt="icon" />
                    </div>
                    <h6 className="fw-bold mb-1">{feature.title}</h6>
                    <p
                      className="text-muted small mb-0"
                      style={{ maxWidth: "90%" }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Coming Soon Section */}
            <div className="text-center mb-3">
              <h4 className="fw-bold text-dark">Coming Soon</h4>
              <p className="text-muted small">New features launching soon</p>
            </div>

            <div className="row g-3 mb-4">
              {comingSoonFeatures.map((feature, index) => (
                <div className="col-12 col-sm-6 col-md-4" key={index}>
                  <div
                    className="border rounded bg-white p-3 h-100 text-center d-flex flex-column align-items-center justify-content-start shadow-sm"
                    style={{ minHeight: "160px" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center mb-2 rounded-circle"
                      style={{
                        backgroundColor: "#eaeaea",
                        width: "65px",
                        height: "65px",
                      }}
                    >
                      <img
                        src={feature.image}
                        width={40}
                        alt="coming soon icon"
                      />
                    </div>
                    <h6 className="fw-bold mb-1">{feature.title}</h6>
                    <p
                      className="text-muted small mb-0"
                      style={{ maxWidth: "90%" }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <div className="text-center mb-4">
              <button
                className="btn btn-primary px-5 py-2 fw-bold fs-5 rounded-pill"
                onClick={() => {
                  window.location.href = "/min-kyc";
                }}
              >
                ACTIVATE CARD NOW
              </button>
            </div>

            {/* Powered By */}
            <hr />
            <div className="text-center">
              <small className="text-muted d-block mb-1">ISSUED BY</small>
              <img
                src="/images/pine-labs-logo.png"
                alt="Pine Labs"
                style={{ height: "22px" }}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default CardIntro;
